// utils/roomRegistry.js
//
// ✅ الهدف: نظام بسيط "شير" بين AuthContext و Messages.jsx يمسك:
// 1) مجموعة الـ roomId بتوع الجروبات اللي اليوزر عضو فيها فعليًا
// 2) roomId الثابت الخاص بجروب "الشركة كلها" (Company Wide)
//
// السبب: عدد الرسائل الغير مقروءة كان بيتخزن في AuthContext بمفتاح
// roomId دايمًا، لكن الشاتات الخاصة في الـ Sidebar كانت بتتقرأ بمفتاح
// userId — mismatch كامل، فالعداد كان يفضل صفر في كل الشاتات الخاصة.

const groupRoomIds = new Set();
let companyRoomId = null;

export function registerGroupRoom(roomId) {
  if (roomId) groupRoomIds.add(String(roomId));
}

export function isGroupRoom(roomId) {
  if (!roomId) return false;
  return groupRoomIds.has(String(roomId));
}

export function setCompanyRoomId(roomId) {
  if (roomId) companyRoomId = String(roomId);
}

export function getCompanyRoomId() {
  return companyRoomId;
}

export function clearRoomRegistry() {
  groupRoomIds.clear();
  companyRoomId = null;
}